import { forwardRef } from 'react';
import { InputBaseComponentProps } from '@mui/material';
import { InputMask } from '../InputWithMask';

export const ZipCodeMask = forwardRef(({ onChange, ...other }: InputBaseComponentProps) => {
  const zipCodeMask = [
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    other.value?.trim()?.length > 5 ? '-' : /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];

  return <InputMask {...other} mask={zipCodeMask} onChange={onChange} />;
});
